import React, { useEffect } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Row, Col, Alert } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

import SellTicketsHeader from '../SellTicketsHeader';
import SellTicketsManually from '../SellTicketsManually';
import SellTicketsLayout from '../SellTicketsLayout';
import AddTicketsModal from '../modals/AddTicketsModal';
import LoginModal from '../modals/LoginModal';
import withAsyncLifecycle from '../../../core/hoc/async-lifecycle';
import formatFloatWithSuperscript from '../../../core/utils/helpers';
import { saveEventId } from '../../services/storage';
import { selectSellEvents } from '../../selectors/sell-tickets';
import { selectHttpInfo } from '../../../core/selectors/http';
import { openModal } from '../../../core/actions/modal';
import { getEvents, SELL_GET_TICKETS_REQUEST_NAME } from '../../actions/sell-tickets';
import { SELL_STEP_1, SELL_STEP_3 } from '../../constants/steps';
import { ADD_TICKETS_MODAL_NAME } from '../../constants/modal';

const SellStep1 = () => {
    const { isFetching, isError } = useSelector((state) => selectHttpInfo(state, SELL_GET_TICKETS_REQUEST_NAME));
    const dispatch = useDispatch();
    const events = useSelector(selectSellEvents);

    useEffect(() => {
        dispatch(getEvents());
    }, []);

    const SellStep1WithAsyncLifecycle = withAsyncLifecycle(SellStep1Content, { isFetching, isError });

    return <SellStep1WithAsyncLifecycle events={events}/>;
};
export default SellStep1;

const SellStep1Content = ({ events }) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const intl = useIntl();
    const goToNextStep = () => navigate(`/sell/${SELL_STEP_3}`);
    const selectEventId = (id) => {
        saveEventId(id);
        goToNextStep();
    };
    const errorNotify = () => toast.error(intl.formatMessage({ id: 'notify_error_message' }));

    return (
        <SellTicketsLayout>
            <AddTicketsModal goToNextStep={goToNextStep} errorNotify={errorNotify}/>
            <LoginModal goToNextStep={() => navigate(`/sell/${SELL_STEP_1}`) } />
            <Row>
                <Col lg={{ span: 10, offset: 1 }} md={12}>
                    {events.length > 0 && (
                        <SellTicketsHeader title={<FormattedMessage id="sell_select_event"/>}
                            subtitle={<FormattedMessage id="sell_select_event_desc"/>}/>
                    )}

                    <div className="events_container">
                        {events.map((event) => (
                            <div className="border rounded p-3 mb-3" key={event.id}>
                                <Row>
                                    <Col xl={3} lg={4} md={5} sm={12}>
                                        <img src={event.photo} alt={event.title} className="img-fluid rounded"/>
                                    </Col>
                                    <Col xl={6} lg={5} md={7} sm={12}>
                                        <h5 className="event_listing_title">{event.title}</h5>
                                        <div className="event_listing_date "><i className="bi bi-calendar"></i> {event.startDateTime}</div>
                                        <div className="event_listing_location"><i className="bi bi-geo-alt"></i> {event.location}</div>
                                        <Alert variant="primary" className="mt-3 mb-0">
                                            <i className="bi bi-tickets"></i>
                                            <FormattedMessage id="sell_you_bought" values={{ noOfTickets: event.noOfTickets }}/>
                                        </Alert>
                                    </Col>
                                    <Col xl={3} lg={3} md={12} className="ticket-container-actions">
                                        <div className="event_actions">
                                            <div className="event_old_price_container">
                                                <span className="text-muted"><FormattedMessage id="sell_you_paid_from"/></span>
                                                <span className="event_price fw-bold">
                                                    {formatFloatWithSuperscript(event.buyPrice)} {event.currency}
                                                </span>
                                                <span className="text-muted"> <FormattedMessage id="per_ticket"/></span>
                                            </div>
                                            <Button onClick={() => selectEventId(event.id)}>
                                                <FormattedMessage id="sell_tickets"/>
                                            </Button>
                                        </div>
                                    </Col>
                                </Row>
                            </div>
                        ))}
                    </div>
                </Col>
            </Row>
            <SellTicketsManually onClick={() => dispatch(openModal(ADD_TICKETS_MODAL_NAME))} hasEvents={events.length > 0}/>
        </SellTicketsLayout>
    );
};
